module.exports = __webpack_public_path__ + "img/theme.d575e933.svg";